module.exports = __webpack_public_path__ + "img/K3m-pYzMTIDucqTY5lhbPYp8Zkc.0bf93c27.png";